module.exports = __webpack_public_path__ + "assets/media/day7.d2453453.mp3";